import { render } from "./ButtonGroup.vue?vue&type=template&id=ab7f22e2&scoped=true&bindings={\"modelValue\":\"props\",\"name\":\"props\",\"label\":\"props\",\"options\":\"props\",\"buttonClass\":\"setup\",\"changeValue\":\"setup\",\"meta\":\"setup\",\"errorMessage\":\"setup\"}"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import "./ButtonGroup.vue?vue&type=style&index=0&id=ab7f22e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ab7f22e2"

export default script